/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FilterPharmaciesDetails } from '../types/FilterPharmaciesDetails'
import { defaultFormatTimeZone } from '../utils/consts'

interface PharmaciesFiltersContextType {
  filters: FilterPharmaciesDetails
  setFilters: (filters: FilterPharmaciesDetails) => any
}
const initialState: PharmaciesFiltersContextType = {
  filters: {
    pharmacies: [],
    createdAt: {
      initialDate: moment().clone().subtract(15, 'days').format('YYYY-MM-DD'),
      finalDate: moment().clone().format('YYYY-MM-DD'),
      ...defaultFormatTimeZone
    }
  },
  setFilters: () => {}
}
const storageItem = 'filters-pharmacies-details-portal-analytics'
let localState: object = {}
if (!isEmpty(sessionStorage.getItem(storageItem))) localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, filters: { ...state.filters, ...newState } }
}

export const PharmaciesDetailsFiltersContext = createContext(initialState)

const PharmaciesDetailsFiltersContextProvider: React.FC = (props: any) => {
  const [filters, setFilters] = useReducer(reducer, !isEmpty(localState) ? localState : initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(filters))
  }, [filters])

  return (
    <PharmaciesDetailsFiltersContext.Provider value={{ ...filters, setFilters }}>
      {props.children}
    </PharmaciesDetailsFiltersContext.Provider>)
}

export default PharmaciesDetailsFiltersContextProvider
